import React, { useState, useEffect, useRef } from 'react';
import './style.css';
import IframeComponent from './IframeComponent';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from 'react-router-dom';
const defaultValues = {
  src: 'https://myweb.ps',
  device: 'desktop',
};

export default function ProductBar(props) {

  const firstUpdate = useRef(true);
  const [data, setData] = useState(defaultValues);
  //let location = useLocation();
 // console.log(props.history);
 // console.log(location);
  let params = new URLSearchParams(props.history.search);
  let site = '';

  useEffect(() => {
    if (firstUpdate.current) {
      if (params) {
        if (params.get('site')) {
          site = params.get('site');
          console.log(site);
          setData({ ...data, src: site });
        }
      }
      firstUpdate.current = false;
      return;
    }
    //  console.log('Not the first update');
    // Do something
  });

  const toggleDevice = (e, device) => {
    console.log(device);
    setData({ ...data, device: device });
  };

  return (
    <>
      <div className="page-loader" style={{ display: 'none' }}>
        <div className="loader-wrap">
          <div className="loader">
            <div className="loader-inner" />
          </div>
        </div>
      </div>
      <div className="page" style={{ display: 'block' }}>
        <div id="header" className="header" style={{ display: 'block' }}>
          <div className="container">
            <div className="row">
              <div className="col-xs-3 col-sm-2 col-md-2">
                <a className="logo" href="https://myweb.ps/">
                  <img src="https://myweb.ps/wp-content/uploads/2018/11/myweb-ecommerce.png" />
                </a>
              </div>
              <div
                className="col-xs-7 col-sm-6 col-md-4"
                style={{ display: 'none' }}
              >
                <div id="product-toggle" className="product-toggle">
                  <span id="product-name" className="product-name">
                    فلات سوم 1
                  </span>
                  <span className="product-btn">
                    <i className="product-show fa fa-angle-down" />
                    <i className="product-hide fa fa-angle-up" />
                  </span>
                </div>
              </div>
              <div className="col-xs-5 col-sm-6 col-md-8">
                <div className="product-toolbar clearfix">
                  <a
                    id="product-frame-close"
                    className="product-frame-close"
                    href={data.src}
                  >
                    <i className="fa fa-times-circle" />
                  </a>
                  <div className="product-buttons hidden-xs">
                    <a
                      id="profile"
                      className="btn btn-primary hidden-sm"
                      href="https://myweb.ps#thesamples"
                    >
                      النماذج
                    </a>
                    <a
                      id="buy"
                      className="btn btn-success"
                      href="https://tgbe.link/myweboffer"
                      style={{ minWidth: '200px', marginLeft: '5px' }}
                    >
                      اضف للسلة
                    </a>
                  </div>
                  <div
                    id="product-devices"
                    className="product-devices hidden-sm hidden-xs"
                  >
                    <Link
                      to="#"
                      className="desktop active"
                      data-device="desktop"
                      title="Desktop"
                      onClick={(e) => {
                        toggleDevice(e, 'desktop');
                      }}
                    />
                    <Link
                      to="#"
                      className="tabletlandscape"
                      data-device="tabletlandscape"
                      title="Tablet Landscape (1024x768)"
                      onClick={(e) => {
                        toggleDevice(e, 'tabletlandscape');
                      }}
                    />
                    <Link
                      to="#"
                      className="tabletportrait"
                      data-device="tabletportrait"
                      title="Tablet Portrait (768x1024)"
                      onClick={(e) => {
                        toggleDevice(e, 'tabletportrait');
                      }}
                    />
                    <Link
                      to="#"
                      className="mobilelandscape"
                      data-device="mobilelandscape"
                      title="Mobile Landscape (480x320)"
                      onClick={(e) => {
                        toggleDevice(e, 'mobilelandscape');
                      }}
                    />
                    <Link
                      to="#"
                      className="mobileportrait"
                      data-device="mobileportrait"
                      title="Mobile Portrait (320x480)"
                      onClick={(e) => {
                        toggleDevice(e, 'mobileportrait');
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="iframe-wrap"
          style={{ opacity: '1', pointerEvents: 'inherit' }}
        >
          <div
            className="iframe-loader"
            style={{ opacity: '0', display: 'none' }}
          >
            <div className="loader-wrap">
              <div className="loader">
                <div className="loader-inner" />
              </div>
            </div>
          </div>
          <IframeComponent dataControl={{ data, setData }} />
          <div className="product-buttons-bottom">
            <a
              id="profile"
              className="btn btn-primary hidden-sm"
              href="https://myweb.ps#thesamples"
            >
              النماذج
            </a>
            <a
              id="buy"
              className="btn btn-success"
              href="https://tgbe.link/myweboffer"
            >
              اضف للسلة
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
